import {
	requestActionHandler,
	successActionHandler,
	failureActionHandler,
} from 'store';
import injectReducer from 'store/injectReducer';
import * as types from '../ActionTypes';
import {
	ISummaryReducer,
	ISummaryRoundsAndSurveyName,
	IHeatmapStatistic,
	ISummaryMetrics,
	IResultService,
	IServiceCardTrends,
	ISummaryClientData,
} from '../models';

export const InitialSummaryReducer: ISummaryReducer = {
	isAllPageLoading: false,
	rounds: [],
	serviceTrends: [],
	locationStatistic: [],
	roleStatistic: [],
	businessUnitStatistic: [],
	services: [],
};

export default injectReducer(InitialSummaryReducer, {
	[types.GET_SUMMARY_ROUNDS.REQUEST]: requestActionHandler,
	[types.GET_SUMMARY_SERVICE_CARDS.REQUEST]: requestActionHandler,
	[types.GET_SUMMARY_METRICS.REQUEST]: requestActionHandler,
	[types.GET_SUMMARY_HEATMAP_STATISTIC.REQUEST]: requestActionHandler,
	[types.GET_SUMMARY_SERVICE_LIST.REQUEST]: requestActionHandler,
	[types.GET_CLIENT_LOGO.REQUEST]: requestActionHandler,
	[types.GET_ALL_SUMMARY_DATA.REQUEST]: (
		state: ISummaryReducer,
	): ISummaryReducer => ({
		...requestActionHandler(state),
		isAllPageLoading: true,
	}),

	[types.GET_ALL_SUMMARY_DATA.FAILURE]: failureActionHandler,
	[types.GET_SUMMARY_ROUNDS.FAILURE]: (
		state: ISummaryReducer,
	): ISummaryReducer => ({
		...requestActionHandler(state),
		errors: {
			...state.errors,
			rounds: true,
		},
	}),
	[types.GET_CLIENT_LOGO.FAILURE]: (
		state: ISummaryReducer,
	): ISummaryReducer => ({
		...requestActionHandler(state),
		errors: {
			...state.errors,
			logo: true,
		},
	}),
	[types.GET_SUMMARY_SERVICE_CARDS.FAILURE]: (
		state: ISummaryReducer,
	): ISummaryReducer => ({
		...requestActionHandler(state),
		errors: {
			...state.errors,
			serviceCards: true,
		},
	}),
	[types.GET_SUMMARY_HEATMAP_STATISTIC.FAILURE]: (
		state: ISummaryReducer,
	): ISummaryReducer => ({
		...requestActionHandler(state),
		errors: {
			...state.errors,
			heatmap: true,
		},
	}),
	[types.GET_SUMMARY_SERVICE_LIST.FAILURE]: (
		state: ISummaryReducer,
	): ISummaryReducer => ({
		...requestActionHandler(state),
		errors: {
			...state.errors,
			services: true,
		},
	}),
	[types.GET_SUMMARY_METRICS.FAILURE]: (
		state: ISummaryReducer,
	): ISummaryReducer => ({
		...requestActionHandler(state),
		errors: {
			...state.errors,
			metrics: true,
		},
	}),
	[types.GET_ALL_SUMMARY_DATA.FAILURE]: (
		state: ISummaryReducer,
		payload: { payload: Error },
	): ISummaryReducer => ({
		...failureActionHandler(state, payload),
		isAllPageLoading: false,
	}),

	[types.GET_ALL_SUMMARY_DATA.SUCCESS]: (
		state: ISummaryReducer,
	): ISummaryReducer => ({
		...successActionHandler(state),
		isAllPageLoading: false,
	}),

	[types.GET_SUMMARY_ROUNDS.SUCCESS]: (
		state: ISummaryReducer,
		{ payload }: { payload: ISummaryRoundsAndSurveyName },
	): ISummaryReducer => ({
		...successActionHandler(state),
		...payload,
	}),

	[types.GET_SUMMARY_SERVICE_CARDS.SUCCESS]: (
		state: ISummaryReducer,
		{ payload: { serviceTrends } }: { payload: IServiceCardTrends },
	): ISummaryReducer => ({
		...successActionHandler(state),
		serviceTrends,
	}),

	[types.GET_SUMMARY_HEATMAP_STATISTIC.SUCCESS]: (
		state: ISummaryReducer,
		{ payload }: { payload: Partial<IHeatmapStatistic> },
	): ISummaryReducer => ({
		...successActionHandler(state),
		...payload,
	}),

	[types.GET_SUMMARY_SERVICE_LIST.SUCCESS]: (
		state: ISummaryReducer,
		{ payload }: { payload: IResultService[] },
	): ISummaryReducer => ({
		...successActionHandler(state),
		services: payload,
	}),

	[types.GET_SUMMARY_METRICS.SUCCESS]: (
		state: ISummaryReducer,
		{ payload }: { payload: ISummaryMetrics },
	): ISummaryReducer => ({
		...successActionHandler(state),
		metrics: payload,
	}),

	[types.GET_CLIENT_LOGO.SUCCESS]: (
		state: ISummaryReducer,
		{ payload: { logoUrl, name } }: { payload: ISummaryClientData },
	): ISummaryReducer => ({
		...successActionHandler(state),
		clientLogoUrl: logoUrl,
		clientName: name,
	}),

	[types.RESET_ERRORS]: (state: ISummaryReducer): ISummaryReducer => ({
		...successActionHandler(state),
		errors: undefined,
	}),
});
